module.exports = __webpack_public_path__ + "static/media/idea.fc892873.png";